<template>
  <div class="loading" v-show="show_loading" @touchmove.prevent>
    <div class="loading_spinner">
      <div v-for="(item, index) in spinner" :key="index"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

function createSpinner() {
  return [...Array(12).fill(0)];
}
export default {
  data() {
    return {
      spinner: createSpinner(),
    };
  },
  computed: {
    ...mapState(["show_loading"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../css/common.scss";
.loading {
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 3;
  top: 0;
  left: 0;
}
.loading_spinner {
  @include vhcenter(80, 80);
  position: absolute;
  width: trans(80);
  height: trans(80);
}
.loading_spinner div {
  transform-origin: trans(40) trans(40);
  animation: spinner 1.2s linear infinite;
}
.loading_spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: trans(4);
  left: trans(37);
  width: trans(6);
  height: trans(18);
  border-radius: 20%;
  background: #fff;
}
.loading_spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.loading_spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.loading_spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.loading_spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.loading_spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.loading_spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.loading_spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.loading_spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.loading_spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.loading_spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.loading_spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.loading_spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}

@keyframes spinner {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202010/unit_member/comp/Loading.vue